"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const provider_user_1 = require("@dzambalaorg/provider-user");
const attach_wallet_1 = require("./attach-wallet");
const styled_1 = require("./styled");
const Wallet = () => {
    const { profile } = (0, provider_user_1.useUser)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.profile.settings.wallet.title" }), (0, jsx_runtime_1.jsxs)(styled_1.StyledTypography, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.profile.settings.wallet.connectedWallet" }), ": ", profile.wallet || "N/A"] }), (0, jsx_runtime_1.jsx)(attach_wallet_1.AttachWalletButton, {})] }));
};
exports.Wallet = Wallet;
//# sourceMappingURL=index.js.map